import { render, staticRenderFns } from "./XQuery.vue?vue&type=template&id=83e89cba&scoped=true&"
import script from "./XQuery.vue?vue&type=script&lang=js&"
export * from "./XQuery.vue?vue&type=script&lang=js&"
import style0 from "./XQuery.vue?vue&type=style&index=0&id=83e89cba&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e89cba",
  null
  
)

export default component.exports